import { useContext } from 'react';

import { FlowStateContext } from '#client/App/FlowStateProvider';

/**
 * Custom hook to retrieve and mutate the state of a flow
 *
 * @returns {import('#client/App/FlowStateProvider').FlowStateContextValue} The flow state context value.
 * @throws {Error} If used outside of a FlowStateProvider.
 */
export default function useFlowState() {
  const context = useContext(FlowStateContext);
  if (!context) {
    return {}; // Allow for use outside of a FlowStateProvider
  }
  return context;
}
